export default {
  setLogoUrl(state, logoUrl) {
    state.logoUrl = logoUrl
  },
}
